import { Component, Input, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'delete-button',
  template: '',
  styleUrls: ['delete-button.component.scss'],
})
export class DeleteButtonComponent {
  @HostBinding('class.no-border')
  @Input() noBorder: boolean = false;
}
